import { Button, Col, Form, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import InputBox from "../../../../components/common/input";
import CommonUpload from "../../../../components/common/upload-image";
import FileUploadTwo from "../../../../components/common/fileUploadFun/FileUploadTwo";
import { useDispatch, useSelector } from "react-redux";
import {
  addAuthor,
  updateAuthor,
  viewAuthor,
} from "../../../../redux/reducer/authorSlice";
import { toast } from "react-toastify";

const AddAuthors = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [previewImages, setPreviewImages] = useState(() => ({
    image_url: "",
  }));
  const location = useLocation();
  const isEditMode = location.pathname.includes("edit");
  const dispatch = useDispatch();
  const params = useParams();

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  const { viewAuthorData } = useSelector((state) => state?.author);

  useEffect(() => {
    if (isEditMode && params?.id) {
      dispatch(viewAuthor(params.id));
    }
  }, [isEditMode, params?.id, dispatch]);

  useEffect(() => {
    if (
      isEditMode &&
      viewAuthorData &&
      Object.keys(viewAuthorData).length > 0
    ) {
      form.setFieldsValue(viewAuthorData);
      setPreviewImages({
        image_url: viewAuthorData.image_url
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewAuthorData.image_url}`
          : null,
      });
    }
  }, [isEditMode, viewAuthorData, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (isEditMode) {
        const response = await dispatch(
          updateAuthor({ id: params?.id, data: values })
        );
        if (response.type === "data/update/author/fulfilled") {
          toast.success("Author updated successfully");
          navigate(-1);
        }
      } else {
        const response = await dispatch(addAuthor(values));
        if (response.payload.code === 201) {
          toast.success(response?.payload?.message);
          navigate(-1);
        } else {
          toast.error(response?.payload?.message);
        }
      }
    } catch (error) {
      console.log("Validation Failed or API Error:", error);
    }
  };

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {isEditMode ? "Edit Author Details" : "Add Author Details"}
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            Save Details
          </Button>
        </Space>
      </div>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col xs={24} sm={24}>
            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Enter author name" }]}
                >
                  <InputBox size="large" placeholder="Enter author name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={16}></Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="about_en"
                  label="About (Max 500 Words) (en)"
                  // rules={[
                  //   { required: true, message: "Enter About in 500 words" },
                  //   {
                  //     max: 500,
                  //     message: "About must be 500 characters or less",
                  //   },
                  // ]}
                >
                  <InputBox
                    placeholder="Enter About in 500 words"
                    className="custom-input"
                    isMultiline
                    rows={4}
                    style={{ height: "100px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="about_es"
                  label="About (Max 500 Words) (es)"
                  // rules={[
                  //   { required: true, message: "Enter About in 500 words" },
                  //   {
                  //     max: 500,
                  //     message: "About must be 500 characters or less",
                  //   },
                  // ]}
                >
                  <InputBox
                    placeholder="Enter About in 500 words"
                    className="custom-input"
                    isMultiline
                    rows={4}
                    style={{ height: "100px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="about_pt"
                  label="About (Max 500 Words) (pt)"
                  // rules={[
                  //   { required: true, message: "Enter About in 500 words" },
                  //   {
                  //     max: 500,
                  //     message: "About must be 500 characters or less",
                  //   },
                  // ]}
                >
                  <InputBox
                    placeholder="Enter About in 500 words"
                    className="custom-input"
                    isMultiline
                    rows={4}
                    style={{ height: "100px" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="image_url"
                  label="Upload Image"
                  // rules={[{ required: true, message: "Please upload a image" }]}
                >
                  <FileUploadTwo
                    maxFileSizeText={
                      "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                    }
                    setFieldValue={(url) =>
                      handleUploadSuccess("image_url", url)
                    }
                    initialPreview={previewImages.image_url}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddAuthors;
